import './App.css';
import Layout from './containers/Layout';

function App() {
  return (
    <div className="App">
      <Layout />
    </div>
  );
}

export default App;
